import React, { ReactElement } from "react";

import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";

import useNavigateWithSearch from "../hooks/use-navigate-with-search";

interface Props {
  open: boolean;
  onClose(): void;
  navPath: string;
}

const BeforeBackActionDialog = ({
  open,
  onClose,
  navPath,
}: Props): ReactElement => {
  const navigate = useNavigateWithSearch();
  const handleClickCancel = (evt: React.MouseEvent): void => {
    evt.preventDefault();
    onClose();
  };

  const handleClickConfirm = (evt: React.MouseEvent): void => {
    evt.preventDefault();
    navigate(navPath, { replace: true });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h4">Go Back?</Typography>
        <IconButton
          color="primary"
          onClick={onClose}
          size="large"
          sx={{ ml: "auto" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Typography variant="h6">
          You have unsaved changes which will be lost if you leave this page.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClickCancel}>Cancel</Button>
        <Button color="primary" onClick={handleClickConfirm}>
          Back
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default BeforeBackActionDialog;
